export default "__VITE_ASSET__CUp6y0hS__"